import Drawable from '../entities/Drawable.js';
import { imageStore } from '../images.js';
import Sprite from './Sprite.js';
import PixelText from './PixelText.js';

export default class VerticalOptionsMenuUI extends Drawable {
    constructor({ menu, position = { x: 0, y: 0 }, visible = false }) {
        super({ position, visible });
        this.menu = menu;
        let boxImage = null;
        switch (this.menu.getOptionsCount()) {
            case 6:
                boxImage = imageStore.get('img/pause_menu_box_112.png');
                break;
            case 5:
                boxImage = imageStore.get('img/pause_menu_box.png');
                break;
            case 4:
                boxImage = imageStore.get('img/menu_box_80x80_empty.png');
                break;
            case 3:
                boxImage = imageStore.get('img/menu_box_64x64_empty.png');
                break;
            case 2:
            case 1:
                boxImage = imageStore.get('img/menu_box_64x48_empty.png');
                break;
        }
        this.sprites = {};
        this.sprites.optionsBox = new Sprite({
            position: { x: this.position.x, y: this.position.y },
            image: boxImage,
            moving: false,
            frames: { max: 1, val: 0 },
            visible: true,
        });
        this.optionsTextArray = [];
        this.menu.options.forEach((option, i) => {
            this.optionsTextArray.push(
                new PixelText({
                    text: option,
                    position: {
                        x: this.position.x + 16,
                        y: this.position.y + 19 - 7 + i * 16,
                    },
                    color: 'black',
                })
            );
        });

        this.sprites.selectionArrow = new Sprite({
            position: {
                x: this.position.x + 8,
                y: this.position.y + 12 + 16 * this.menu.currentOption,
            },
            image: imageStore.get('img/selection_arrow.png'),
            moving: false,
            frames: { max: 1, val: 0 },
        });
    }

    update(menu) {
        this.menu = menu;
        let boxImage = null;
        switch (this.menu.getOptionsCount()) {
            case 6:
                boxImage = imageStore.get('img/pause_menu_box_112.png');
                break;
            case 5:
                boxImage = imageStore.get('img/pause_menu_box.png');
                break;
            case 4:
                boxImage = imageStore.get('img/menu_box_80x80_empty.png');
                break;
            case 3:
                boxImage = imageStore.get('img/menu_box_64x64_empty.png');
                break;
            case 2:
            case 1:
                boxImage = imageStore.get('img/menu_box_64x48_empty.png');
                break;
        }
        this.sprites = {};
        this.sprites.optionsBox = new Sprite({
            position: { x: this.position.x, y: this.position.y },
            image: boxImage,
            moving: false,
            frames: { max: 1, val: 0 },
            visible: true,
        });
        this.optionsTextArray = [];
        this.menu.options.forEach((option, i) => {
            this.optionsTextArray.push(
                new PixelText({
                    text: option,
                    position: {
                        x: this.position.x + 16,
                        y: this.position.y + 12 - 7 + i * 16,
                    },
                    color: 'black',
                })
            );
        });

        this.sprites.selectionArrow = new Sprite({
            position: {
                x: this.position.x + 8,
                y: this.position.y + 12 + 16 * this.menu.currentOption,
            },
            image: imageStore.get('img/selection_arrow.png'),
            moving: false,
            frames: { max: 1, val: 0 },
        });
    }

    draw() {
        this.visible = this.menu.isActive;
        if (!this.visible) {
            return;
        }
        if (this.menu.position) {
            this.position.x = this.menu.position.x;
            this.position.y = this.menu.position.y;
            this.sprites.optionsBox.position.x = this.menu.position.x;
            this.sprites.optionsBox.position.y = this.menu.position.y;
            this.sprites.selectionArrow.position.x = this.menu.position.x + 8;
            this.sprites.selectionArrow.position.y = this.menu.position.y + 12 + 16 * this.menu.currentOption;
        }
        this.sprites.optionsBox.draw();
        this.optionsTextArray.forEach((option, i) => {
            if (this.menu.position) {
                option.position.x = this.menu.position.x + 16;
                option.position.y = this.menu.position.y + 12 + i * 16;
            }
            option.draw();
        });
        this.sprites.selectionArrow.position = {
            x: this.position.x + 8,
            y: this.position.y + 12 + 16 * this.menu.currentOption,
        };
        this.sprites.selectionArrow.draw();
    }
}
